import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../graphql/fragments/generated/User';
import { EntityMediaFragmentDoc } from '../../../../../features/messages/graphql/fragments/generated/MediaType';
import { TagDataFragmentDoc } from '../../../../corporate/modules/tags/views/TagsManager/graphql/fragments/generated/TagData';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateUserMutationVariables = Types.Exact<{
  input: Types.UpdateUserInput;
}>;


export type UpdateUserMutation = { updateUser: { meta?: string | null, timezone?: string | null, status: Types.UserStatusEnum, unreadNotificationsCount: number, unresolvedNotificationsCount: number, id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, socials?: Array<{ type: Types.UserSocialAccountTypeEnum, link: string }> | null, tags?: Array<{ tagId: string, type?: Types.TagTypeEnum | null, optionIdValues?: Array<string> | null, numberValue?: number | null, textValue?: string | null, isEditable?: boolean | null, options?: Array<{ id: string, name: string }> | null, users?: Array<{ id: string, name?: string | null, profilePicture?: string | null }> | null, dateValue?: { startTime?: string | null, endTime?: string | null } | null }> | null, preferences?: { showMarketplaceContentCatalogBanner?: boolean | null } | null, orgRole?: { id: string, name: string } | null } };


export const UpdateUserDocument = /*#__PURE__*/ gql`
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(data: $input) {
    ...User
    cover {
      ...EntityMedia
    }
    socials {
      type
      link
    }
    meta
    timezone
    tags {
      ...TagData
    }
    status
    preferences {
      showMarketplaceContentCatalogBanner
    }
    unreadNotificationsCount
    unresolvedNotificationsCount
  }
}
    ${UserFragmentDoc}
${EntityMediaFragmentDoc}
${TagDataFragmentDoc}`;

export function useUpdateUserMutation() {
  return Urql.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument);
};